import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import MemberContactDialog from "@icoach/members/dialog/MemberContactDialog";
import SendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import { CheckoutCreditOrderDialog } from "@icoach/memberDetail/dialog/";
import GiftDispatchDialog from "@icoach/gift/dialog/GiftDispatchDialog";
import { isFunction, isEqual } from "@util/utils";
import { useHistory } from "react-router-dom";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import BatchMemberShipQuitDialog from "@icoach/members/dialog/BatchMembershipQuitDialog";
import CrossClubWorkoutDatesDialog from "@icoach/members/dialog/CrossClubWorkoutDatesDialog";

const BATCH_MEMBERSHIP_QUIT = "batch-membership-quit";
const SENDSMS = "sendSMS";
const MEMBERCONTACT = "memberContact";
const GIFTDISPATCH = "giftDispatch";
const CREDITORDER = "creditOrder";
const CROSS_CLUB_WORKOUT_DATES = "crossClubWorkoutDates";

const MemberDialogBox = React.forwardRef((props, ref) => {
	const { setContactState, refresh: refreshProps } = props;
	const history = useHistory();
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	const handleGiftDispatchRefresh = () => {
		history.push(CLUB_MEMBERS_ROUTER.GIFT.GET_TABS_PATH("dispatch-record"));
	};

	const handleRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			refreshRef.current(...arg);
		}
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openSmsDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(SENDSMS);
				},
				openContactDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(MEMBERCONTACT);
				},
				openContactGroupDialog: (targetData, filterType, defaultContactResultType) => {
					setSourceData({ ...targetData, filterType, defaultContactResultType });
					setOpenDialog(MEMBERCONTACT);
				},
				openOrderDialog: (target, _refreshFn = () => {}) => {
					refreshRef.current = _refreshFn;
					setSourceData(target);
					setOpenDialog(CREDITORDER);
				},
				openGiftDispatchDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(GIFTDISPATCH);
				},
				openBatchMembershipQuitDialog: (targetData, _refreshFn = () => {}) => {
					setSourceData(targetData);
					setOpenDialog(BATCH_MEMBERSHIP_QUIT);
					refreshRef.current = _refreshFn;
				},
				openCrossClubWorkoutDatesDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(CROSS_CLUB_WORKOUT_DATES);
				},
				closeDialog: () => handleCloseDialog(),
			};
		},
		[]
	);

	useEffect(
		() => {
			if (!openDialog) {
				refreshRef.current = null;
				setSourceData(null);
			}
		},
		// eslint-disable-next-line
		[openDialog]
	);

	if (!openDialog) return null;
	// 不要參考這一隻，需修改 refresh 應該統一來源，不該分兩段 TODO: Allen
	return (
		<React.Fragment>
			<SendSmsDialog open={isEqual(openDialog, SENDSMS)} onClose={handleCloseDialog} sourceData={sourceData} refresh={refreshProps} />
			<MemberContactDialog open={isEqual(openDialog, MEMBERCONTACT)} onClose={handleCloseDialog} sourceData={sourceData} setContactState={setContactState} refresh={refreshProps} />
			<GiftDispatchDialog open={isEqual(openDialog, GIFTDISPATCH)} onClose={handleCloseDialog} sourceData={sourceData} refresh={handleGiftDispatchRefresh} />
			<CheckoutCreditOrderDialog open={isEqual(openDialog, CREDITORDER)} onClose={handleCloseDialog} sourceData={sourceData} refresh={handleRefresh} />
			<BatchMemberShipQuitDialog open={isEqual(openDialog, BATCH_MEMBERSHIP_QUIT)} onClose={handleCloseDialog} sourceData={sourceData} setContactState={setContactState} refresh={refreshProps} />
			<CrossClubWorkoutDatesDialog open={isEqual(openDialog, CROSS_CLUB_WORKOUT_DATES)} onClose={handleCloseDialog} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default MemberDialogBox;
